import { z } from 'zod';

export const ComponentColors = z.object({
  //? Text colors
  primaryTextColor: z.string().default('#00936e'),
  secondaryTextColor: z.string().default('#111827'),
  tertiaryTextColor: z.string().default('#6B7280'),

  //? Button colors
  primaryButtonBackgroundColor: z.string().default('#00936e'),
  primaryButtonTextColor: z.string().default('#FFFFFF'),
  primaryButtonHoverColor: z.string().default('#005f47'),

  secondaryButtonBackgroundColor: z.string().default('#ededed'),
  secondaryButtonTextColor: z.string().default('#00936e'),
  secondaryButtonHoverColor: z.string().default('#f3f4f6'),

  //? Highlight colors
  highlightBackgroundColor: z.string().default('#f3fef9'),
  highlightTextColor: z.string().default('#15803d'),
  highlightHoverColor: z.string().default('#e5fcf1'),

  //? Indicator colors
  indicatorDefaultColor: z.string().default('#E9ECEF'),
  indicatorSelectedColor: z.string().default('#00936e'),
  indicatorHoverColor: z.string().default('#CED4DA'),

  //? BackGround colors
  backgroundColor: z.string().default('#FAF9F6'),
  backgroundHoverColor: z.string().default('#f3f4f6'),
  backgroundLightColor: z.string().default('#f9fafb'),
  backgroundDarkColor: z.string().default('#9ca3af'),

  //? Scrollbar colors
  scrollbarTrackColor: z.string().default('#e5e7eb'),
  scrollbarThumbColor: z.string().default('#00936e'),

  //? Map colors
  pinClusterBackgroundColor: z.string().default('#fb923c'),
  pinClusterTextColor: z.string().default('#FFFFFF'),
});

export type ComponentColors = z.infer<typeof ComponentColors>;

export const defaultComponentColors: ComponentColors = ComponentColors.parse({});


/**
 * Initializes CSS custom properties (variables) on an HTML element based on the provided colors.
 * @param el - The HTML element to apply the CSS variables to
 * @param colors - The color values to use
 */
export const initColors = (el: HTMLElement, colors: ComponentColors) => {
  colors = ComponentColors.parse(colors);
  Object.entries(colors).forEach(([key, value]) => {
    const cssVar = '--' + key.replace(/([A-Z])/g, '-$1').toLowerCase();
    el.style.setProperty(cssVar, value);
  });
};
